/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { Add, Clear, Delete, Edit } from '@mui/icons-material';
import {
  Button,
  Checkbox,
  Chip,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Switch,
  TextField,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { findPersianDefinition } from 'src/utils/findPersianOrder';

export function useForceUpdate() {
  const [value, setValue] = useState(0);
  return () => setValue((value) => value + 1);
}

export const StepExam = ({ exam, setExam, hasExam, setHasExam, error, examLength, setExamLength }) => {
  const [activeQuestion, setActiveQuestion] = useState(1);
  const [qError, setQError] = useState(false);
  const [answerError, setAnswerError] = useState(false);

  const checkEmptyQuestions = () => {
    return exam.map(({ question }) => question === '').includes(true);
  };
  const checkEmptyOptions = () => {
    return exam.map(({ options }) => options.some((option) => option === '')).includes(true);
  };
  const checkNotAnswered = () => {
    return exam.map(({ answer }) => answer === '').includes(true);
  };
  const appendQuestion = () => {
    if (checkEmptyQuestions()) {
      setQError(true);
      return;
    }
    if (checkEmptyOptions()) {
      setAnswerError(true);
      return;
    }
    setActiveQuestion(exam.length);
    const newQuestion = {
      title: '',
      point: 0,
      options: ['', ''],
      answer: '',
    };
    setExam([...exam, newQuestion]);
  };

  useEffect(() => {
    exam.length > 0 ? setActiveQuestion(exam.length - 1) : setActiveQuestion(1);
  }, [exam.length]);
  return (
    <>
      <FormControlLabel
        control={
          <Switch
            checked={hasExam}
            onChange={() => {
              setHasExam(!hasExam);
              setExam([]);
            }}
          />
        }
        label="این گام آزمون دارد"
      />
      {error && hasExam && exam.length === 0 && (
        <Typography variant="caption" sx={{ display: 'block', color: '#FF4842' }}>
          لطفا سوالات خود را اضافه کنید *
        </Typography>
      )}

      {hasExam &&
        exam.map((question, index) => (
          <QuestionBox
            key={index}
            qIndex={index + 1}
            question={question}
            questions={exam}
            setQuestions={setExam}
            activeQuestion={activeQuestion + 1}
            setActiveQuestion={(aq) => !checkEmptyQuestions() && setActiveQuestion(aq)}
            qError={qError}
          />
        ))}
      {hasExam && (
        <Divider sx={{ my: 3 }}>
          {checkNotAnswered() || checkEmptyOptions() ? (
            checkNotAnswered() ? (
              <Chip label="لطفا پاسخ سوال را مشخص کنید" variant="outlined" />
            ) : (
              <Chip label="لطفا همه گزینه های خالی را پر کنید" variant="outlined" />
            )
          ) : (
            <Button onClick={appendQuestion} endIcon={<Add />} variant="contained">
              افزودن سوال
            </Button>
          )}
        </Divider>
      )}
      {hasExam && (
        <Grid item xs={6}>
          <TextField
            label="تعداد سوالات مطرح شده"
            value={examLength}
            onChange={(e) => {
              if (e.target.valueAsNumber > exam.length || e.target.valueAsNumber < 0) return;
              setExamLength(e.target.valueAsNumber);
            }}
            fullWidth
            type="number"
            helperText={`تعداد کل سوالات‌ : ${exam.length}`}
            error={error && hasExam && (examLength === 0 || examLength > exam.length)}
            autoComplete="off"
          />
        </Grid>
      )}
    </>
  );
};

const QuestionBox = ({ qIndex, questions, setQuestions, question, activeQuestion, setActiveQuestion, qError }) => {
  const forceUpdate = useForceUpdate();
  const { options } = question;
  const isActive = activeQuestion === qIndex;

  const appendOption = () => {
    const copyQuestions = [...questions];
    const findQuestion = copyQuestions[qIndex - 1];
    const newValue = '';
    findQuestion.options.push(newValue);
    setQuestions(copyQuestions);
    forceUpdate();
  };
  const onChange = (index, value, type) => {
    const copyQuestions = [...questions];
    const findQuestion = copyQuestions[qIndex - 1];
    if (type === 'question') {
      const newValue = value;
      findQuestion.title = newValue;
    } else if (type === 'point') {
      const newValue = value;
      findQuestion.point = newValue;
    } else if (type === 'option') {
      findQuestion.options[index] = value;
    } else if (type === 'answer') {
      findQuestion.answer = value;
    }
    setQuestions(copyQuestions);
    forceUpdate();
  };
  const onDeleteQustion = (index) => {
    if (questions.length === 1 || questions.length === 0) {
      setQuestions([]);
    } else {
      setQuestions([...questions.slice(0, index), ...questions.slice(index + 1)]);
      setActiveQuestion(questions.length - 2);
    }
  };
  const onEditQuestion = () => {
    setActiveQuestion(qIndex - 1);
    forceUpdate();
  };
  const onDeleteOption = (index) => {
    const copyQuestions = [...questions];
    let findQuestion = copyQuestions?.[qIndex - 1];
    let findOptions = findQuestion?.options;
    if (findOptions?.length === 2) return;
    const findOption = findOptions?.[index];
    const filterArr = findQuestion?.options?.filter((x) => x !== findOption);
    findOptions = filterArr;
    findQuestion.options = findOptions;
    setQuestions(copyQuestions);
    forceUpdate();
  };

  return (
    <Grid container spacing={3} sx={{ my: 'auto' }} alignItems="center">
      <Grid item xs={12}>
        <Chip variant="outlined" color="primary" label={`سوال ${findPersianDefinition(qIndex)}`} />
      </Grid>
      <Grid item xs={12} sx={{ display: 'flex', alignItems: 'center' }}>
        <TextField
          placeholder="سوال"
          fullWidth
          multiline
          value={question?.title}
          onChange={(e) => onChange(qIndex - 2, e.target.value, 'question')}
          disabled={!isActive}
          error={qError && question.title === ''}
          InputProps={{
            endAdornment: (
              <>
                <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 3, bgcolor: '#7635dc' }} />
                <IconButton onClick={() => onDeleteQustion(qIndex - 1)}>
                  <Delete />
                </IconButton>
                <IconButton onClick={() => onEditQuestion(qIndex)}>
                  <Edit />
                </IconButton>
              </>
            ),
          }}
          autoComplete="off"
        />
      </Grid>
      {isActive &&
        options.map((option, index) => {
          return (
            <Grid item xs={6} key={index}>
              <TextField
                placeholder={`گزینه ${index + 1}`}
                fullWidth
                value={option}
                onChange={(e) => onChange(index, e.target.value, 'option')}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {options.length > 2 && (
                        <IconButton onClick={() => onDeleteOption(index)}>
                          <Clear />
                        </IconButton>
                      )}
                      <Checkbox
                        checked={question.answer === index}
                        onChange={(e) => onChange(index, index, 'answer')}
                      />
                    </InputAdornment>
                  ),
                }}
                autoComplete="off"
              />
            </Grid>
          );
        })}
      {isActive && (
        <Grid item xs={12}>
          <Button onClick={appendOption} endIcon={<Add />}>
            افزودن گزینه
          </Button>
        </Grid>
      )}
    </Grid>
  );
};
